import { z } from 'zod';

// ============================================
// 故事历史向量记忆类型
// ============================================

export const StoryVectorMemoryContentKindSchema = z.enum(['full_session', 'session_chunk', 'excerpt']);
export type StoryVectorMemoryContentKind = z.infer<typeof StoryVectorMemoryContentKindSchema>;

export const StoryVectorMemoryRecordSchema = z.object({
  id: z.string(),
  createdAt: z.number(),
  sourceSummaryEntryId: z.string().optional(),
  sourceArchiveRecordId: z.string().optional(),
  sourceSessionKey: z.string(),
  sceneName: z.string().optional(),
  participantIds: z.array(z.string()).default([]),
  participantNames: z.array(z.string()).default([]),
  focusCharacterName: z.string().optional(),
  startedAt: z.number(),
  endedAt: z.number(),
  startedGameTime: z.string().optional(),
  endedGameTime: z.string().optional(),
  contentKind: StoryVectorMemoryContentKindSchema.default('full_session'),
  sourceMessageIds: z.array(z.string()).default([]),
  chunkIndex: z.number().int().nonnegative().optional(),
  content: z.string(),
  embedding: z.array(z.number()).optional(),
  metadata: z.record(z.string(), z.unknown()).optional(),
});
export type StoryVectorMemoryRecord = z.infer<typeof StoryVectorMemoryRecordSchema>;

export const StoryVectorMemoryRecordInputSchema = StoryVectorMemoryRecordSchema.omit({
  id: true,
  createdAt: true,
}).extend({
  id: z.string().optional(),
  createdAt: z.number().optional(),
});
export type StoryVectorMemoryRecordInput = z.infer<typeof StoryVectorMemoryRecordInputSchema>;

export const StoryVectorMemoryQuerySchema = z.object({
  sourceSummaryEntryId: z.string().optional(),
  sourceArchiveRecordId: z.string().optional(),
  sourceSessionKey: z.string().optional(),
  sceneName: z.string().optional(),
  participantId: z.string().optional(),
  sourceMessageId: z.string().optional(),
  contentKind: StoryVectorMemoryContentKindSchema.optional(),
  keyword: z.string().optional(),
  limit: z.number().int().positive().optional(),
});
export type StoryVectorMemoryQuery = z.infer<typeof StoryVectorMemoryQuerySchema>;

export const StoryVectorMemoryStateSchema = z.object({
  records: z.array(StoryVectorMemoryRecordSchema),
  maxEntries: z.number().int().positive().default(3000),
});
export type StoryVectorMemoryState = z.infer<typeof StoryVectorMemoryStateSchema>;
